var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgCrossGray = function SvgCrossGray(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 9,
    height: 9,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "m.75 8.25 7.5-7.5M8.25 8.25.75.75",
    stroke: "#656B6F",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
};
export { SvgCrossGray as ReactComponent };
export default __webpack_public_path__ + "7eba0a842564a31ff6062e992f249266.svg";